import React, { PureComponent } from 'react';
import Select from 'react-select';
import { FormattedMessage } from 'react-intl';
import {
  Label,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  Button,
  Fade,
  ButtonDropdown,
} from 'reactstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { string, array } from 'prop-types';
import SVG from 'react-inlinesvg';
import { STATIC_PATH } from '../../config';

const makeDomains = (domains = [], encId, subAccount) => {
  const subAcc = subAccount ? `/${subAccount}` : '';

  return domains.map(({ id, domain }) => ({
    label: `http://${domain}/${encId}${subAcc}`,
    value: id,
  }));
};

class FlowParkedDomain extends PureComponent {
  static propTypes = {
    domains: array.isRequired,
    encId: string.isRequired,
    subAccount: string,
  };

  static defaultProps = {
    domains: [],
    encId: '',
    subAccount: '',
  };

  constructor(props) {
    super(props);

    const domains = makeDomains(props.domains, props.encId, props.subAccount);

    this.state = {
      copied: false,
      domains,
      selected: domains[0],
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const domains = makeDomains(nextProps.domains, nextProps.encId, nextProps.subAccount);
    const { value } = this.state.selected;
    const selected = domains.find((domain) => value === domain.value) || null;

    this.setState(() => ({ domains, selected }));
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  handleChange = (selected) => {
    if (selected) {
      this.setState(() => ({ selected }));
    }
  };

  handleCopy = () => {
    this.setState(
      () => ({ copied: true }),
      () => {
        setTimeout(() => {
          this._mounted && this.setState(() => ({ copied: false }));
        }, 1200);
      },
    );
  };

  render() {
    const { copied, selected, domains } = this.state;
    const { sm } = this.props;

    return (
      <FormGroup className="form-group-upper-label">
        <Label for="flow-parked-domain">
          <FormattedMessage id="flow.form.parked-domain" defaultMessage="Parked domain" />
          {/* <Fade in={copied} tag="span" className="copy-message">
            <FormattedMessage id="flow.copied" defaultMessage="copied to clipboard" />
          </Fade> */}
        </Label>
        <InputGroup>
          <Select
            className={sm ? 'Select--sm' : ''}
            id="flow-parked-domain"
            clearable={false}
            value={selected}
            options={domains}
            onChange={this.handleChange}
          />
          <InputGroupAddon addonType="append">
            <CopyToClipboard text={selected.label} onCopy={this.handleCopy}>
              <Button type="button" color="primary">
                {copied ? (
                  <Fade in={copied} tag="span" className="copy-message">
                    <SVG
                      src={`${STATIC_PATH}/img/action-icons/check.svg`}
                      height="20"
                      width="20"
                      cacheRequests
                    />
                  </Fade>
                ) : (
                  <SVG
                    src={`${STATIC_PATH}/img/action-icons/copy_flow.svg`}
                    height="20"
                    width="20"
                    cacheRequests
                  />
                )}
              </Button>
            </CopyToClipboard>
          </InputGroupAddon>
        </InputGroup>
      </FormGroup>
    );
  }
}

export default FlowParkedDomain;
